<div class="gift-card">
  <div class="header">
    <div class="header-left">
      <img src="../../../../assets/images/gift-card-logo.png" alt="Voucher Logo">
      <div class="ms-2">
        <h4>{{ card.title }}</h4>
        <p>Created on: {{ card.formattedCreatedAt }}</p>
      </div>
    </div>
    <div class="dropdown">
      <button class="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
        . . .
      </button>
      <ul class="dropdown-menu">
        <li>
          <a class="dropdown-item" (click)="onEditGiftCard()" style="color: rgba(147, 147, 147, 1);">
            <img src="../../../../assets/images/pencil.svg" alt=""> Edit
          </a>
        </li>
        <li>
          <a class="dropdown-item text-danger" (click)="openDeleteGiftCardModal(card.uid)">
            <img src="../../../../assets/images/TrashSimple.svg" alt=""> Delete
          </a>
        </li>
      </ul>
    </div>
  </div>

  <img class="main-gift-img" [src]="card.imageUrl" alt="Voucher Image">

  <h3>{{ card.title }}</h3>
  <p>{{ card.description }}</p>

  <div class="bottom">
    <div class="form-check form-switch d-flex align-items-center">
      <input
        class="form-check-input"
        style="cursor: pointer;" 
        type="checkbox" 
        [checked]="card.active" 
        (change)="onCheckboxChange($event, card)" 
        id="giftActive" 
        name="giftActive">
      <label class="form-check-label" for="giftActive">Active</label>
    </div>
    <p>Expire date: {{ formatedDate  }}</p>
  </div>
</div>


<!-- Delete Confirmation Modal -->
<div class="modal fade delete-gc-modal"  [id]="'deleteGiftCardModal-' + card.uid" tabindex="-1" aria-labelledby="deleteGiftCardLabel" aria-hidden="true" >
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteGiftCardLabel">Delete Voucher</h5>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this voucher?
      </div>
      <div class="modal-footer">
        <button type="button" class="hover-button" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="hover-button" (click)="onDeleteGiftCard(card.uid)">Delete</button>
      </div>
    </div>
  </div>
</div>

<!-- Status Confirmation Modal -->
<div class="modal fade delete-gc-modal" [id]="'confirmStatusModal-' + card.uid" tabindex="-1" aria-labelledby="confirmStatusModalLabel" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmStatusModalLabel">{{ originalStatus ? 'Deactivate' : 'Activate' }} voucher</h5>
      </div>
      <div class="modal-body">
        Are you sure you want to {{ originalStatus ? 'deactivate' : 'activate' }} this voucher?
      </div>
      <div class="modal-footer">
        <button type="button" class="hover-button" (click)="cancelToggle()">No</button>
        <button type="button" class="hover-button" [style.background-color]="originalStatus ? 'rgba(255, 105, 105, 1)' : 'rgba(50, 206, 255, 1)'" (click)="confirmToggleActive(card.uid)">Yes</button>
      </div>
    </div>
  </div>
</div>
